// All bilingual strings. Each leaf is { en, cn }.
// Later: lists like `insights` / `practices` and the `founder` object can
// be replaced with API-fetched data of the same shape.

const T = {
  nav: {
    home:     { en: "Home",      cn: "首 页" },
    firm:     { en: "Firm",      cn: "事 务 所" },
    practice: { en: "Practice",  cn: "业 务" },
    founder:  { en: "Founder",   cn: "创 始 人" },
    insights: { en: "News & Insights",  cn: "新 闻 与 洞 察" }
  },

  hero: {
    eyebrow:    { en: "Dexon Legal",          cn: "德 铉 律 师" },
    eyebrowCn:  { en: "德 铉 律 师 事 务 所", cn: "事 务 所" },
    l1pre:      { en: "Where complexity",     cn: "寻 " },
    l1em:       { en: "",                     cn: "明 晰" },
    l1post:     { en: "",                     cn: "" },
    l2pre:      { en: "meets ",               cn: "于 繁 复" },
    l2em:       { en: "clarity",              cn: "" },
    l2post:     { en: ".",                    cn: "" },
    cnLine:     { en: "PRIVATE CLIENT · WEALTH PLANNING", cn: "私 人 客 户 · 财 富 规 划" },
    statement: {
      en: "For families and principals navigating wealth across borders, generations, and jurisdictions — with something worth protecting.",
      cn: "为您及家人守护值得守护之物 —— 跨境、跨代、跨法域。"
    },
  },

  ticker: {
    en: [
      "Counsel to Families Globally",
      "Wealth Structuring", "Succession", "Family Governance",
      "Cross-Border Planning", "Strictly by Introduction"
    ],
    cn: [
      "服 务 全 球 家 族",
      "财 富 架 构 设 计", "传 承 安 排", "家 族 治 理",
      "跨 境 规 划", "仅 限 引 荐"
    ]
  },

  firm: {
    pageTitle: { en: "The firm",       cn: "事 务 所" },
    pageLede: {
      en: "Dexon Legal is a private client advisory practice. The firm advises families and family offices on the structuring, succession, governance, and cross-border planning of private wealth.",
      cn: "德铉律师事务所，是一家专注于私人客户事务之事务所，为家族与家族办公室，提供私人财富之结构设计、传承安排、治理及跨境规划之顾问。"
    },
    lede: {
      en: "A private client advisory practice for high-net-worth families and family offices across Asia — built on",
      cn: "为亚洲高净值家族与家族办公室服务之私人客户顾问所 — 立于"
    },
    ledeEmphasis: {
      discretion: { en: "discretion",  cn: "克 制" },
      precision:  { en: "precision",   cn: "精 准" },
      continuity: { en: "continuity",  cn: "持 续" }
    },
    principleLabel: { en: "Principle", cn: "原 则" }
  },

  principles: [
    {
      num: "01",
      name: { en: "Discretion", cn: "克 制" },
      body: {
        en: "Counsel is given quietly. The firm's name appears on no league table, in no client list, and on no marketing surface beyond this site. Matters that reach us, stay with us.",
        cn: "顾问之事，从不张扬。本所之名，不入任何榜单，不上任何宣传。受托之事，始于此，亦终于此。"
      }
    },
    {
      num: "02",
      name: { en: "Precision", cn: "精 准" },
      body: {
        en: "Every memorandum is meticulously drafted and rigorously reviewed by the partner team before issuance. The structures we establish are designed to remain clear and legible to the family in twenty years, rather than merely impressive on the day of signing.",
        cn: "每一份备忘录，皆由合伙人团队精心拟定，并经严格审阅把关后方会发出。所立架构，贵在二十年后仍清晰可读，而非仅在签署当日印象深刻。"
      }
    },
    {
      num: "03",
      name: { en: "Continuity", cn: "持 续" },
      body: {
        en: "We serve families across generations. The firm that advises the founder today will be the same firm that advises their grandchildren decades later.",
        cn: "我们服务跨代传承的家族。今日为创始人提供服务的律所，数十年后，仍将是为其孙辈提供服务的律所。"
      }
    }
  ],

  practice: {
    pageTitle: { en: "Areas of practice", cn: "业 务 领 域" },
    lede: {
      en: "Dexon Legal advises on the disciplines that touch private wealth where Chinese law and international jurisdictions meet.",
      cn: "德铉致力于在中国与海外法域交汇之处，就私人财富相关准则提供顾问意见。"
    }
  },

  practices: [
    {
      num: "I",
      name: { en: "Family Law", cn: "家 事 法" },
      desc: {
        en: "Marriage, property, and family relationships sit at the heart of many of the most consequential decisions a family will ever make. We advise international families with PRC connections, and Chinese families with cross-border arrangements, on prenuptial and postnuptial agreements, division of matrimonial property, child custody and guardianship, as well as the management and disposition of family assets both inside and outside China. This work requires not only a deep understanding of Chinese law and judicial practice, but also a nuanced grasp of how Chinese courts approach cross-border disputes — and, beyond the law itself, a prudent and empathetic approach to matters that touch both legal rights and human relationships.",
        cn: "婚姻、财产与亲属关系问题，往往牵动家族最为重大的决定。我们为与中国内地有关联的国际家族，以及在境外有安排的中国家族，提供婚前与婚后协议、夫妻财产分割、子女抚养与监护，以及境内外家族资产处置等专业服务。此类事务既需要对中国法律及司法实践有透彻理解，也需要准确把握中国法院处理涉外纠纷的思路，更需要在法律框架之外，以审慎和体恤的态度，处理这些兼具法律意义与人情温度的家族事务。"
      }
    },
    {
      num: "II",
      name: { en: "Wealth Structuring", cn: "财 富 架 构" },
      desc: {
        en: "We design and implement the vehicles through which families hold, govern, and pass on their wealth — private trusts, foundations, holding companies, insurance arrangements, and multi-generational structures built to endure. Our work is firmly rooted in Chinese realities: the nature of the assets, the wishes of the settlor, the family's specific circumstances, and the prevailing regulatory environment for Chinese wealth. We work closely with trustees, banks, and offshore counsel to build bridges between assets in mainland China and offshore jurisdictions, ensuring that the structures we establish today remain robust, clear, and effective in ten, twenty, or even fifty years' time.",
        cn: "我们为家族设计并搭建持有、治理与传承财富的各类工具——私人信托、基金会、控股公司、保险安排，以及可跨越数代的传承架构。我们的工作深深植根于中国的现实：资产的性质、设立人的意愿、家族的具体情况，以及中国财富当前的监管环境。我们与受托人、银行及离岸律师紧密协作，搭建连接中国内地资产与境外司法辖区的桥梁，并确保今日设立的架构，在十年、二十年乃至五十年后依然稳健有效、清晰可执行。"
      }
    },
    {
      num: "III",
      name: { en: "Succession & Estates", cn: "传 承 与 遗 产" },
      desc: {
        en: "Few questions weigh more heavily on a family than how wealth will pass from one generation to the next. We advise on wills, succession arrangements, and the orderly cross-generational and cross-border transmission of wealth. When the time comes, we also assist with estate administration and distribution, wherever the assets are located. Our clients frequently hold diverse assets across multiple jurisdictions — ranging from operating businesses and listed company shares to real estate, collectibles, and trust interests. This work demands not only technical precision, but also patience and empathy, as we accompany families through what is often an emotionally complex and difficult period.",
        cn: "对家族而言，鲜有问题比财富如何从上一代传至下一代更为牵动人心。我们就遗嘱、传承安排，以及财富跨代、跨境的有序传递提供专业咨询；在需要之时，亦协助处理遗产承办与分配事宜，无论资产位于何处。我们的客户往往在多个司法辖区持有形式多样的资产，包括经营性企业、上市公司股份、不动产、收藏品及信托权益等。此类工作既需要技术上的精准，也常常需要足够的耐心与同理心，陪伴家族走过那段情感复杂、并不轻松的时光。"
      }
    },
    {
      num: "IV",
      name: { en: "Cross-Border Planning", cn: "跨 境 规 划" },
      desc: {
        en: "Most of the families we serve live across multiple jurisdictions — with the founder in mainland China, children studying or residing overseas, and assets spread across Hong Kong, Singapore, the United Kingdom, the United States, and other locations. We take primary responsibility for the PRC law aspects, while working closely with trusted lawyers, tax advisors, and trustees in the relevant jurisdictions. We coordinate these efforts to deliver a fully integrated and harmonious solution for the family — one in which the Chinese and offshore arrangements complement rather than conflict with each other.",
        cn: "我们所服务的家族，大多跨越不止一个司法辖区——创始人在中国内地，子女在海外求学或定居，资产分布于香港、新加坡、英国、美国及其他地方。我们负责协调中国法层面的安排，与上述司法辖区中值得信赖的律师、税务顾问及受托人紧密协作。我们承担中国一侧的核心责任，并与境外专业伙伴精诚配合，最终目标是为家族呈上一份完整、协调的整体方案——使中国与境外的安排相互呼应、相得益彰，而非彼此冲突或掣肘。"
      }
    },
    {
      num: "V",
      name: { en: "Family Office Advisory", cn: "家 族 办 公 室 顾 问" },
      desc: {
        en: "The quality of a family office depends on the strength of the structures it is built upon and the governance that runs through it. We advise on the establishment of single-family and multi-family offices, the design of their governance frameworks, and the legal architecture supporting their investment, succession, and philanthropic activities. We also assist existing family offices with periodic reviews — revisiting structures established years ago to ensure they remain aligned with the family's current needs and circumstances. Our clients include both families setting up a family office for the first time and institutions that build and service platforms for others.",
        cn: "家族办公室的水准，取决于其所依托的架构与贯穿其中的治理。我们为单一家族办公室及联合家族办公室的设立、治理框架的搭建，以及支撑其投资、传承与慈善活动的法律架构提供专业咨询。我们亦协助既有家族办公室进行定期检视——回顾多年前设立的架构，审视其是否依然契合当下家族的需求与情况。我们的客户既包括首次设立家族办公室的家族，也包括为他人搭建服务平台的专业机构。"
      }
    },
    {
      num: "VI",
      name: { en: "Disputes & Mediation", cn: "争 议 与 调 解" },
      desc: {
        en: "When disagreements arise between family members, between beneficiaries and trustees, or during estate administration, our preference — and that of most of our clients — is for a discreet and confidential resolution rather than public litigation. We handle disputes relating to family matters, trusts, estates, and succession issues, which frequently span multiple jurisdictions. Where mediation or private negotiation is the more appropriate route, we lead the process; where litigation is unavoidable, we prepare thoroughly and respond with care. Whichever path is chosen, our consistent goal is to resolve the dispute effectively without allowing it to fracture the family.",
        cn: "当家族成员之间、受益人与受托人之间，或在遗产承办过程中出现分歧时，我们——以及我们的大多数客户——倾向于以审慎、保密的方式予以解决，而非诉诸公开诉讼。我们处理家事、信托及遗产相关的争议，以及传承过程中的纠纷，所涉事务常常横跨多个司法辖区。当调解或私下协商是更合适的路径时，我们主导推进；当诉讼不可避免时，我们悉心准备、谨慎应对。无论选择何种路径，我们的目标始终如一：有效解决争议，但绝不让家族因此而破裂。"
      }
    }
  ],

  quote: {
    label:  { en: "A note from the senior partner", cn: "高 级 合 伙 人 之 言" },
    text: {
      en: "The matters that come to us are rarely urgent and never small. We answer them in the manner in which they were entrusted to us.",
      cn: "委托之事，少急而无小。我等所答，不辜所望。"
    },
    cite:   { en: "Wei Lan Cheng · Chair", cn: "程 维 兰 · 主 席" }
  },

  founderSec: {
    pageTitle: { en: "Founder of the firm",  cn: "本 所\n创 始 人" },
    lede: {
      en: "New clients come to us only by referral. Once a client decides to engage us, we bring everything we know to the relationship — and we sustain it, across a lifetime and into the generations that follow. The firm grows only when it must.",
      cn: "新客户唯经引荐，一旦决意相托，我们便倾尽所知所学，维系这份情谊——相守一生，泽及后代。非必要，不扩张。"
    },
    portrait: { en: "PORTRAIT", cn: "肖 像" }
  },

  founder: {
    name: { en: "WANG Xiaogang (Steven)",    cn: "王 小 刚 (Steven)" },
    role: { en: "Founding Partner",          cn: "创 始 合 伙 人" },
    bio: {
      en: "Steven is the founding partner of the firm. He is one of the first generation of private client lawyers in Mainland China, and has spent more than twenty years advising successful families on the questions that matter most to them — how to pass on wealth, protect what they have built, and prepare the next generation for what lies ahead.\n\nHe works with founders, shareholders of listed companies, entrepreneurs, artists and performers, and the financial institutions that serve them. His practice centres on family trusts and succession planning, cross-border philanthropy, and the administration of estates across multiple jurisdictions — together with pre-immigration arrangements and incentive and shareholding structures for the companies families control. He is often called upon when a family's affairs span several countries, generations, or currencies, and where a settled hand and long perspective are needed.\n\nAlongside this work, Steven advises on contentious and non-contentious family and estate matters, from prenuptial and marital property arrangements to contested estates and inheritance claims. He has also helped private banks, trust companies and family offices in Mainland China and overseas build out their wealth planning capabilities.\n\nSteven is qualified as a lawyer in the People's Republic of China and works in Chinese and English. He is the author of What Happens When the First Generation of Wealth Grows Old — Private Trusts and Wealth Planning (2012) and Common Law Trusts: Theory and Practice (2016).",
      cn: "王小刚律师为本所创始合伙人。他是中国内地最早从事私人财富法律业务的律师之一，二十余年来始终为成功家族解答他们最为关切的问题——财富如何传承，基业如何守护，下一代如何迎接未来。\n\n他的客户包括创始人、上市公司股东、企业家、艺术家与演艺人士，以及为他们提供服务的金融机构。其执业以家族信托与传承规划、跨境慈善以及跨法域遗产管理为核心，并涵盖移民前财富安排，以及家族所控企业的股权与激励架构。每当家族事务横跨数个国家、数代人或数种货币，需要沉稳的手笔与长远的眼光时，他常是家族托付之人。\n\n此外，王律师亦处理争议性与非争议性的家事及遗产事务，自婚前协议与夫妻财产安排，至遗产争议与继承纠纷。他还曾协助中国内地及海外的私人银行、信托公司与家族办公室搭建财富规划体系。\n\n王律师为中华人民共和国执业律师，以中英文双语执业。著有《富一代老了怎么办——私人信托与财富规划》（2012）及《普通法信托：理论与实务》（2016）。"
    }
  },

  insightsSec: {
    pageTitle: { en: "News & Insights", cn: "新 闻 与 洞 察" },
    articlesError: { en: "Articles could not be loaded. Please try again.", cn: "文章加载失败，请重试。" },
    mediaError: { en: "Media could not be loaded. Please try again.", cn: "媒体内容加载失败，请重试。" },
    retry: { en: "Retry", cn: "重试" },
    lede: {
      en: "Occasional writings on recurring issues and questions encountered in our practice. This section also curates news and information in the private client wealth management field that we believe is worth sharing.",
      cn: "偶有著述，探讨执业中常见之疑难问题。本节亦汇集私人客户财富管理领域的新闻与资讯，与各位分享。"
    },
    readMore: { en: "Read the note", cn: "阅 读 全 文" },
    archive:  { en: "View the full archive", cn: "全 部 文 章" },
    tabs: {
      notes: { en: "Notes",             cn: "短 札" },
      media: { en: "Long-form & Media", cn: "长 论 与 多 媒 体" }
    },
    loadMore:  { en: "Load more", cn: "加 载 更 多" },
    mediaEmpty:{
      en: "Long-form pieces and recorded conversations — published as they are written.",
      cn: "长 论 与 录 像 — 著 一 篇 · 发 一 篇。"
    },
    videoPending: { en: "Video — coming soon", cn: "录 像 — 待 发 布" }
  },

  insights: [
    {
      cat:  { en: "Note",       cn: "短 札" },
      date: { en: "March · 2026", cn: "二 〇 二 六 · 三 月" },
      title: { en: "On the Quiet Trust: structures that do not need to perform",
               cn: "论 静 默 信 托：不 必 表 演 之 架 构" },
      excerpt: {
        en: "A reflection on the temptation to over-engineer wealth structures, and why the simplest valid form is most often the one that survives the second generation intact.",
        cn: "议过度构架财富之诱惑，及最简之有效形式何以最常完好传至第二代。"
      }
    },
    {
      cat:  { en: "Memorandum", cn: "备 忘" },
      date: { en: "February · 2026", cn: "二 〇 二 六 · 二 月" },
      title: { en: "PRC heirship rules and the trap of the foreign will",
               cn: "境 内 继 承 法 与 境 外 遗 嘱 之 陷 阱" },
      excerpt: {
        en: "Where mainland-situs assets meet a foreign-law will, a disciplined two-instrument approach remains the only reliable answer. Drafting notes from a recent matter.",
        cn: "凡境内资产遇境外法之遗嘱，惟严谨之两文书并行，方为可靠之答。撷自近期案例之拟稿笔记。"
      }
    },
    {
      cat:  { en: "Reading",    cn: "阅 读" },
      date: { en: "January · 2026", cn: "二 〇 二 六 · 一 月" },
      title: { en: "Reading the 2026 amendments to the Trust Law",
               cn: "评 二 〇 二 六 信 托 法 修 订" },
      excerpt: {
        en: "Three observations on the latest round of amendments, with particular attention to the position of the protector and the supervision of charitable purpose trusts.",
        cn: "就最新一轮修订之三点观察，尤注于保护人之地位及公益目的信托之监管。"
      }
    }
  ],

  // Long-form & media items. Backend will populate `videoUrl` / `coverImage`
  // when each piece is published; the frontend renders a placeholder slide
  // until then.
  media: [
    {
      title: { en: "[ Title — placeholder ]",            cn: "[ 标 题 — 占 位 ]" },
      date:  { en: "March · 2026",                       cn: "二 〇 二 六 · 三 月" },
      intro: { en: "[ Intro paragraph — placeholder for the recorded conversation, to be filled in by the firm. ]",
               cn: "[ 简 介 段 — 待 本 所 填 写 之 录 像 简 述。 ]" },
      videoUrl: "",
      coverImage: "",
      autoPlay: false,
      muted: true
    },
    {
      title: { en: "[ Title — placeholder ]",            cn: "[ 标 题 — 占 位 ]" },
      date:  { en: "February · 2026",                    cn: "二 〇 二 六 · 二 月" },
      intro: { en: "[ Intro paragraph — placeholder for a long-form essay published with accompanying video. ]",
               cn: "[ 简 介 段 — 待 本 所 填 写 之 长 论 与 配 像。 ]" },
      videoUrl: "",
      coverImage: "",
      autoPlay: false,
      muted: true
    },
    {
      title: { en: "[ Title — placeholder ]",            cn: "[ 标 题 — 占 位 ]" },
      date:  { en: "January · 2026",                     cn: "二 〇 二 六 · 一 月" },
      intro: { en: "[ Intro paragraph — placeholder for archived material from earlier in the year. ]",
               cn: "[ 简 介 段 — 年 初 之 旧 文 占 位。 ]" },
      videoUrl: "",
      coverImage: "",
      autoPlay: false,
      muted: true
    }
  ],

  footer: {
    headings: {
      firm:     { en: "Firm",         cn: "事 务 所" },
      practice: { en: "Practice",     cn: "业 务" },
      contact:  { en: "Contact",      cn: "联 络" }
    },
    firmLinks: [
      { en: "About",    cn: "关 于" },
      { en: "Founder",  cn: "创 始 人" },
      { en: "Insights", cn: "洞 察" }
    ],
    byIntro:  { en: "By introduction only",  cn: "仅 限 引 荐" },
    email:    { en: "contact@dexonlegal.com", cn: "contact@dexonlegal.com" },
    legal:    { en: "© 2026 Dexon Legal. All rights reserved.", cn: "© 2026 德铉律师事务所. 版权所有." },
    bottom: [
      { en: "Privacy",          cn: "隐 私" },
      { en: "Notices",          cn: "声 明" }
    ]
  },

  legal: {
    updated: { en: "Last updated: 11 June 2026", cn: "最后更新：2026 年 6 月 11 日" },

    privacy: {
      pageTitle: { en: "Privacy Policy", cn: "隐私政策" },
      intro: {
        en: [
          "This Privacy Policy explains how Dexon Legal (the “Firm”, “we”, “us” or “our”) collects, uses, discloses and protects personal information in connection with this website and any communications you have with us through it. Please read it carefully.",
          "For the purposes of applicable data protection law, including the General Data Protection Regulation (Regulation (EU) 2016/679) (the “GDPR”) and the Personal Information Protection Law of the People’s Republic of China (the “PIPL”), the Firm is the controller (and, under the PIPL, the personal information handler) responsible for your personal information."
        ],
        cn: [
          "本隐私政策说明德铉律师事务所（下称“本所”“我们”）在本网站及您经由本网站与我们进行的任何沟通中，如何收集、使用、披露及保护个人信息。敬请您仔细阅读。",
          "就适用的数据保护法律而言，包括《通用数据保护条例》（欧盟 2016/679 号条例，下称“GDPR”）及《中华人民共和国个人信息保护法》（下称“个人信息保护法”），本所为对您的个人信息负责的控制者（在个人信息保护法项下为个人信息处理者）。"
        ]
      },
      sections: [
        {
          heading: { en: "Personal information we collect", cn: "我们收集的个人信息" },
          body: {
            en: [
              "Information you provide to us. When you contact us by email or through any enquiry or contact form on this website, we collect the personal information you choose to provide, which may include:",
              { list: [
                "your name, title and the organisation you represent;",
                "your email address, telephone number and other contact details; and",
                "the content of your enquiry and any information or documents you choose to include in your correspondence with us."
              ] },
              "Information we collect automatically. When you visit this website, our hosting provider’s servers automatically record certain technical information, which may include your Internet Protocol (IP) address, browser type and version, operating system, referring website, and the date and time of your visit. Your language preference is stored locally within your own browser and is not transmitted to us.",
              "This website is only a point of initial contact and is not a secure channel for confidential matters. Before a professional engagement has been agreed with us in writing, please do not disclose, through our contact email or any enquiry form, any sensitive personal information or confidential details of your affairs — including information concerning health, family or marital matters, financial accounts or assets, identity documents, whereabouts, or any minor. A brief, general description of the nature of your matter is sufficient at this stage."
            ],
            cn: [
              "您向我们提供的信息。当您通过电子邮件或本网站上的任何咨询或联系表单与我们联系时，我们会收集您选择提供的个人信息，可能包括：",
              { list: [
                "您的姓名、职务及您所代表的机构；",
                "您的电子邮箱、电话及其他联系方式；以及",
                "您咨询的内容，以及您在与我们的通信中选择提供的任何信息或文件。"
              ] },
              "我们自动收集的信息。当您访问本网站时，我们主机服务商的服务器会自动记录某些技术信息，可能包括您的互联网协议（IP）地址、浏览器类型及版本、操作系统、来源网站，以及您访问的日期与时间。您的语言偏好仅存储于您本地的浏览器中，不会传送至我们处。",
              "本网站仅为初步联系的窗口，并非处理保密事务的安全渠道。在与我们以书面方式约定专业委托之前，敬请勿通过我们的联系邮箱或任何咨询表单披露任何敏感个人信息或涉及您事务的保密细节，包括有关健康、家庭或婚姻状况、金融账户或资产、身份证件、行踪轨迹，以及任何未成年人的信息。在此阶段，仅需就您事务的性质作简要、概括的说明即可。"
            ]
          }
        },
        {
          heading: { en: "Sensitive personal information", cn: "敏感个人信息" },
          body: {
            en: [
              "We do not seek to collect sensitive personal information through this website. If, despite the above, you provide us with sensitive personal information (such as information about health, family circumstances, financial accounts, identity, whereabouts, or a minor), we will process it only where there is a specific purpose and sufficient necessity, and we will apply enhanced protective measures to it. Where the PIPL so requires, we will process such information only on the basis of your separate consent, after informing you of the necessity of the processing and its impact on your rights; where the information is not necessary for your matter, we will delete it. The personal information of a minor under the age of 14 will be processed only with the consent of a parent or other guardian and in accordance with rules established for that purpose."
            ],
            cn: [
              "我们不会主动通过本网站收集敏感个人信息。若您仍向我们提供了敏感个人信息（例如有关健康、家庭状况、金融账户、身份、行踪轨迹或未成年人的信息），我们仅在具有特定目的和充分必要性的前提下予以处理，并对其采取更为严格的保护措施。在《个人信息保护法》要求的情形下，我们将在向您告知处理的必要性及其对您权益的影响后，基于您的单独同意方予处理；对于并非处理您事务所必需的此类信息，我们将予以删除。对于不满十四周岁未成年人的个人信息，我们仅在取得其父母或其他监护人同意、并依照为此制定的专门规则的情形下方予处理。"
            ]
          }
        },
        {
          heading: { en: "How we use your personal information", cn: "我们如何使用您的个人信息" },
          body: {
            en: [
              "We use your personal information for the following purposes:",
              { list: [
                "to respond to your enquiry and to communicate with you;",
                "to consider and, where appropriate, to establish and perform a professional engagement;",
                "to operate, maintain and secure this website;",
                "to comply with our legal, regulatory and professional obligations; and",
                "to establish, exercise or defend legal claims where necessary."
              ] },
              "We do not sell, rent or trade personal information, and we do not use your personal information for unsolicited marketing."
            ],
            cn: [
              "我们将您的个人信息用于下列目的：",
              { list: [
                "回应您的咨询并与您沟通；",
                "审阅并在适当情形下建立及履行专业委托；",
                "运营、维护并保障本网站的安全；",
                "遵守我们的法律、监管及职业义务；以及",
                "在必要时确立、行使或抗辩法律主张。"
              ] },
              "我们不出售、出租或交易个人信息，亦不将您的个人信息用于未经请求的营销。"
            ]
          }
        },
        {
          heading: { en: "Legal bases for processing", cn: "处理的合法性基础" },
          body: {
            en: [
              "Where the GDPR applies, we process your personal information on one or more of the following legal bases: (a) our legitimate interests in responding to enquiries and conducting our practice, provided these are not overridden by your interests or fundamental rights; (b) the performance of a contract with you, or steps taken at your request prior to entering into a contract; (c) compliance with a legal obligation to which we are subject; and (d) where applicable, your consent.",
              "Where the PIPL applies, we process personal information on the bases permitted under that law, which may include your consent, the necessity of processing for the conclusion or performance of a contract to which you are a party, and the necessity of processing in order to fulfil our statutory duties or obligations. Where we rely on your consent, you may withdraw it at any time as described in section 10."
            ],
            cn: [
              "在适用 GDPR 的情形下，我们基于下列一项或多项合法性基础处理您的个人信息：（a）我们在回应咨询及开展执业方面的正当利益，且该利益未被您的利益或基本权利所凌驾；（b）为与您履行合同，或在订立合同前应您请求采取的步骤；（c）遵守我们所负的法定义务；及（d）在适用情形下，您的同意。",
              "在适用《个人信息保护法》的情形下，我们基于该法所许可的基础处理个人信息，可能包括您的同意、为订立或履行以您为一方的合同所必需，以及为履行我们的法定职责或义务所必需。在我们以您的同意为基础进行处理时，您可按第 10 节所述随时撤回该同意。"
            ]
          }
        },
        {
          heading: { en: "Sharing and disclosure", cn: "个人信息的共享与披露" },
          body: {
            en: [
              "We treat your personal information with care and disclose it only as necessary. We may share your personal information with:",
              { list: [
                "service providers who host, maintain or support this website on our behalf and who are bound by obligations of confidentiality and data protection;",
                "courts, regulators, law enforcement or other authorities, where required by applicable law or professional rules; and",
                "professional advisers and other third parties where necessary to establish, exercise or defend legal claims."
              ] },
              "We do not transfer your personal information to third parties for their own marketing purposes."
            ],
            cn: [
              "我们审慎对待您的个人信息，仅在必要时予以披露。我们可能与下列各方共享您的个人信息：",
              { list: [
                "代我们托管、维护或支持本网站，并负有保密及数据保护义务的服务提供商；",
                "在适用法律或职业规则要求的情形下，法院、监管机关、执法机关或其他主管机关；以及",
                "在确立、行使或抗辩法律主张所必需的情形下，专业顾问及其他第三方。"
              ] },
              "我们不会为第三方自身的营销目的而向其转移您的个人信息。"
            ]
          }
        },
        {
          heading: { en: "International transfers", cn: "个人信息的跨境传输" },
          body: {
            en: [
              "The Firm and its service providers may be located in more than one jurisdiction, and the matters we handle may have connections to several jurisdictions. As a result, your personal information may be transferred to, stored in, or processed in countries or regions other than the one in which you are located, including jurisdictions in Asia, Europe and elsewhere that may not provide the same level of data protection as your own.",
              "Where we transfer personal information across borders, we take the steps required by applicable law to ensure an adequate level of protection. Depending on the jurisdiction concerned, these may include entering into the standard contract for the cross-border provision of personal information formulated by the competent authority of the People’s Republic of China, or the standard contractual clauses or other safeguards recognised under other applicable laws, and, where required, obtaining your separate consent and conducting a personal information protection impact assessment."
            ],
            cn: [
              "本所及其服务提供商可能位于不止一个法域，我们所处理的事务亦可能与多个法域相关。因此，您的个人信息可能被传输至、存储于或处理于您所在国家或地区以外的国家或地区，包括亚洲、欧洲及其他地区中可能未提供与您所在地相同水平之数据保护的法域。",
              "凡我们跨境传输个人信息，均将采取适用法律所要求的措施以确保充分的保护水平。视所涉法域而定，此类措施可能包括按照中华人民共和国主管部门制定的个人信息出境标准合同、或其他适用法律下认可的标准合同条款或其他保障措施与境外接收方订立合同，并在法律要求时取得您的单独同意及进行个人信息保护影响评估。"
            ]
          }
        },
        {
          heading: { en: "Data security", cn: "个人信息的安全" },
          body: {
            en: [
              "We maintain reasonable administrative, technical and physical safeguards designed to protect personal information against accidental or unlawful loss, misuse, alteration and unauthorised access. However, no method of transmission over the Internet, and no method of electronic storage, is completely secure, and we cannot guarantee absolute security."
            ],
            cn: [
              "我们采取合理的管理、技术及物理保障措施，旨在保护个人信息免遭意外或非法的丢失、滥用、篡改及未经授权的访问。然而，互联网上的任何传输方式及任何电子存储方式均非绝对安全，我们无法保证万无一失。"
            ]
          }
        },
        {
          heading: { en: "Data retention", cn: "个人信息的留存" },
          body: {
            en: [
              "We retain personal information only for as long as is necessary for the purposes for which it was collected, or for as long as required to satisfy our legal, regulatory and professional obligations, including any obligation to retain client and matter records for a prescribed period, after which it will be deleted or anonymised."
            ],
            cn: [
              "我们仅在为收集目的所必需的期间，或为满足我们的法律、监管及职业义务（包括按规定期限保存委托与案件档案的义务）所要求的期间内留存个人信息，此后将予以删除或匿名化处理。"
            ]
          }
        },
        {
          heading: { en: "Cookies and local storage", cn: "Cookie 与本地存储" },
          body: {
            en: [
              "This website does not use cookies or similar technologies for advertising, profiling or third-party analytics. We use only the local storage of your browser to remember your language preference; this information remains on your device and is not transmitted to us. Should we introduce any additional cookies or analytics in future, we will update this Privacy Policy and, where required, seek your consent."
            ],
            cn: [
              "本网站不使用 Cookie 或类似技术进行广告、画像或第三方统计分析。我们仅使用您浏览器的本地存储来记住您的语言偏好；该信息保留在您的设备上，不会传送至我们处。若我们日后引入任何额外的 Cookie 或统计分析，我们将更新本隐私政策，并在法律要求时征得您的同意。"
            ]
          }
        },
        {
          heading: { en: "Your rights", cn: "您的权利" },
          body: {
            en: [
              "Subject to and in accordance with applicable law, you may have the right to request access to the personal information we hold about you; to request that it be corrected or deleted; to restrict or object to its processing; to request its portability; and, where processing is based on consent, to withdraw that consent at any time without affecting the lawfulness of processing carried out before withdrawal. Under the PIPL, you may also have the right to request an explanation of our processing rules.",
              "To exercise any of these rights, please contact us using the details set out below. We will respond within the period required by applicable law. If you are not satisfied with our response, you may have the right to lodge a complaint with the data protection or personal information protection authority competent in your own country or region. In the People’s Republic of China, this is the authority performing personal information protection duties."
            ],
            cn: [
              "在适用法律的范围内并依其规定，您可能有权请求访问我们所持有的关于您的个人信息；请求更正或删除该信息；限制或反对对其处理；请求其可携带性；以及，在处理以同意为基础的情形下，随时撤回该同意，但不影响撤回前已进行之处理的合法性。在《个人信息保护法》项下，您还可能有权请求我们对处理规则作出解释说明。",
              "如欲行使上述任一权利，敬请使用下方所载方式与我们联系。我们将在适用法律所要求的期限内予以回应。若您对我们的回应不满意，您可能有权向您所在国家或地区有管辖权的数据保护或个人信息保护主管机关投诉；在中华人民共和国，该机关为履行个人信息保护职责的有关主管机关。"
            ]
          }
        },
        {
          heading: { en: "Children", cn: "未成年人" },
          body: {
            en: [
              "This website is intended for adults and is not directed at children. We do not knowingly collect personal information from children. Where an adult provides us with personal information concerning a minor, we will handle that information in the manner described in section 2 (Sensitive personal information). If you believe that a child has provided us with personal information, please contact us so that we may delete it."
            ],
            cn: [
              "本网站面向成年人，并非面向未成年人。我们不会在知情的情况下收集未成年人的个人信息。若成年人向我们提供有关未成年人的个人信息，我们将按第 2 节（敏感个人信息）所述方式处理该等信息。若您认为某位未成年人向我们提供了个人信息，敬请与我们联系，以便我们予以删除。"
            ]
          }
        },
        {
          heading: { en: "Changes to this Privacy Policy", cn: "本隐私政策的变更" },
          body: {
            en: [
              "We may update this Privacy Policy from time to time to reflect changes in our practices or in applicable law. The date at the top of this page indicates when it was last revised. Material changes will be posted on this page and will take effect upon posting."
            ],
            cn: [
              "我们可能不时更新本隐私政策，以反映我们实践或适用法律的变化。本页顶部的日期表明其最近修订之时。重大变更将公布于本页，并自公布之时起生效。"
            ]
          }
        },
        {
          heading: { en: "How to contact us", cn: "如何与我们联系" },
          body: {
            en: [
              "If you have any questions about this Privacy Policy, or wish to exercise your rights, please contact us at:",
              { list: [
                "Dexon Legal — Data Protection",
                "[Registered firm name and registered office address to be inserted]",
                "Email: contact@dexonlegal.com"
              ] }
            ],
            cn: [
              "若您对本隐私政策有任何疑问，或希望行使您的权利，敬请通过下列方式与我们联系：",
              { list: [
                "德铉律师事务所 — 数据保护事务",
                "[此处填入律所注册全称及注册办公地址]",
                "电子邮箱：contact@dexonlegal.com"
              ] }
            ]
          }
        }
      ]
    },

    notices: {
      pageTitle: { en: "Legal Notices", cn: "法律声明" },
      intro: {
        en: [
          "Please read these Legal Notices carefully. By accessing and using this website, you agree to the terms set out below. If you do not agree to them, please do not use this website."
        ],
        cn: [
          "敬请仔细阅读本法律声明。访问及使用本网站，即表示您同意下列条款。如您不同意，敬请勿使用本网站。"
        ]
      },
      sections: [
        {
          heading: { en: "No legal advice", cn: "不构成法律意见" },
          body: {
            en: [
              "The information on this website is provided for general information purposes only. It does not constitute legal or other professional advice, is not a substitute for advice from a qualified lawyer, and should not be relied upon as such. The law differs between jurisdictions and changes over time, and the information on this website may not be current or complete. You should obtain specific professional advice before taking, or refraining from taking, any action on the basis of the contents of this website."
            ],
            cn: [
              "本网站所载信息仅供一般参考之用，不构成法律或其他专业意见，不能替代合格律师所提供的咨询，亦不应被作为此类意见而加以信赖。法律因法域而异，并随时间而变，本网站所载信息未必最新或完整。在依据本网站内容作为或不作为之前，您应取得具体的专业意见。"
            ]
          }
        },
        {
          heading: { en: "No lawyer–client relationship", cn: "不建立委托关系" },
          body: {
            en: [
              "Accessing this website, or contacting the Firm through it, does not create a lawyer–client relationship between you and the Firm. Such a relationship arises only upon the execution of a formal engagement agreed in writing between you and the Firm.",
              "This website is intended only as a means of initial contact. Any communication you send to us through it, including by email or any enquiry form, may not be treated as confidential and is not protected by the duty of confidentiality that arises between a lawyer and a client. Please do not send us, through our contact email or any form on this website, any confidential or sensitive information about yourself or your affairs until a formal engagement has been agreed in writing. Unsolicited information sent before that time will not give rise to any duty of confidentiality on our part and will not, of itself, prevent the Firm from acting for another party, subject to the professional rules applicable to us."
            ],
            cn: [
              "访问本网站，或经由本网站与本所联系，并不在您与本所之间建立律师与客户之关系。此种关系仅在您与本所以书面方式订立正式委托时方告成立。",
              "本网站仅作为初步联系的途径。您经由本网站（包括通过电子邮件或任何咨询表单）向我们发送的任何沟通，未必被作为保密信息对待，亦不受律师与客户之间所产生之保密义务的保护。在以书面方式约定正式委托之前，敬请勿通过我们的联系邮箱或本网站的任何表单，向我们发送任何有关您本人或您事务的保密或敏感信息。在此之前未经请求发送的信息，不会使本所因此负有保密义务，亦不会仅因此妨碍本所为另一方提供服务，但本所仍受适用于我们的职业规则约束。"
            ]
          }
        },
        {
          heading: { en: "No warranty and limitation of liability", cn: "免责与责任限制" },
          body: {
            en: [
              "This website and its contents are provided on an “as is” and “as available” basis, without warranty of any kind, whether express or implied. The Firm does not warrant that this website will be available without interruption, or that it or its contents are accurate, complete or free from error.",
              "To the fullest extent permitted by applicable law, the Firm accepts no liability for any loss or damage of any kind arising out of, or in connection with, the access to, use of, or reliance upon this website or its contents."
            ],
            cn: [
              "本网站及其内容按“现状”及“现有”基础提供，不附任何明示或默示的担保。本所不保证本网站将不间断地可供使用，亦不保证本网站或其内容准确、完整或毫无差错。",
              "在适用法律允许的最大范围内，本所对因访问、使用或信赖本网站或其内容而引起或与之相关的任何种类的损失或损害，概不承担责任。"
            ]
          }
        },
        {
          heading: { en: "Intellectual property", cn: "知识产权" },
          body: {
            en: [
              "All content on this website, including text, design, layout, graphics, and the Dexon Legal name and logo, is owned by or licensed to the Firm and is protected by copyright, trade mark and other intellectual property rights. You may view this website and print or download extracts for your own personal, non-commercial use, provided that you do not alter the content and that the Firm is acknowledged as the source. No part of this website may otherwise be reproduced, transmitted or adapted without the prior written consent of the Firm."
            ],
            cn: [
              "本网站上的全部内容，包括文字、设计、版式、图形，以及“德铉律师事务所”之名称与标识，均为本所所有或经许可使用，并受著作权、商标权及其他知识产权保护。您可浏览本网站，并为您个人的、非商业性的使用而打印或下载摘录，但前提是您不得修改内容，且须注明本所为来源。除此之外，未经本所事先书面同意，不得对本网站的任何部分进行复制、传输或改编。"
            ]
          }
        },
        {
          heading: { en: "Links to other websites", cn: "第三方网站链接" },
          body: {
            en: [
              "This website may contain links to websites maintained by third parties. Such links are provided for convenience only. The Firm does not control, and is not responsible for, the contents of any third-party website, and the inclusion of any link does not imply endorsement by the Firm."
            ],
            cn: [
              "本网站可能包含指向第三方所维护网站的链接。提供此类链接仅为便利之故。本所不控制亦不对任何第三方网站的内容负责，且任何链接的纳入并不意味着本所对其的认可。"
            ]
          }
        },
        {
          heading: { en: "Regulatory information", cn: "监管信息" },
          body: {
            en: [
              "Dexon Legal is a law firm established under the laws of the People’s Republic of China. [The Firm’s registered name, practising licence number, registered office address and supervising judicial administrative authority to be inserted.]"
            ],
            cn: [
              "德铉律师事务所是一家依据中华人民共和国法律设立的律师事务所。[此处填入律所注册全称、执业许可证号、注册办公地址及监管的司法行政机关。]"
            ]
          }
        },
        {
          heading: { en: "Governing law", cn: "适用法律" },
          body: {
            en: [
              "These Legal Notices, and any matter arising out of or in connection with your use of this website, are governed by the laws of the People’s Republic of China."
            ],
            cn: [
              "本法律声明，以及因您使用本网站而引起或与之相关的任何事项，均受中华人民共和国法律管辖。"
            ]
          }
        },
        {
          heading: { en: "Contact", cn: "联系方式" },
          body: {
            en: [
              "Questions regarding these Legal Notices may be directed to contact@dexonlegal.com."
            ],
            cn: [
              "就本法律声明的疑问，可致函 contact@dexonlegal.com。"
            ]
          }
        }
      ]
    }
  },

  articleDetail: {
    loading: { en: "Loading article", cn: "正在加载文章" },
    error: { en: "This article could not be loaded. Please try again.", cn: "文章加载失败，请重试。" },
    timeout: { en: "This article took too long to load. Please try again.", cn: "文章加载超时，请重试。" },
    missing: { en: "Article not found.", cn: "文章不存在或已下架。" },
    back: { en: "Back to News & Insights", cn: "返回新闻与洞察" },
  },

  common: {
    backToHome: { en: "Return to home", cn: "返 回 首 页" }
  }
};

export default T;
